import { createGraphqlFetcher } from '@apis/createFetcher';

type IntegrationPlatform = 'GA4' | 'shopify';

export interface Integration {
    platform: IntegrationPlatform;
    profileId: string;
    enable: boolean;
    properties: string[];
    lastEnableTime?: number;
}

// getIntegrationConfigs 返回值
export type IntegrationConfig = {
    id: string;
} & Integration;

// CreateOrUpdateIntegration 输入值
export type UpdateIntegrationInput = { id?: string } & Integration;

const apis = {
    getIntegrationConfigs: {
        name: 'getIntegrationConfigs',
        query: `query getIntegrationConfigs($profileId:String!) {
            getIntegrationConfigs(profileId:$profileId) {
                id
                platform
                profileId
                enable
                properties
                lastEnableTime
            }
        }`
    },

    createOrUpdateIntegrationConfig: {
        name: 'createOrUpdateIntegrationConfig',
        query: `mutation createOrUpdateIntegrationConfig($input:UpdateIntegrationInput!) {
            createOrUpdateIntegrationConfig(input:$input)
        }`
    },

    getIntegrationApiList: {
        name: 'getAllAPIKeys',
        query: `query getAllAPIKeys($profileId:String!){
            getAllAPIKeys(profileId:$profileId) {
                id
                profileId
                name
                createTime
                updateTime
                createBy
                status
                secretAsterisk
            }
        }`
    },

    createAPIKey: {
        name: 'createAPIKey',
        query: `mutation createAPIKey($input: APIKeyInput!){
            createAPIKey(input:$input)
        }`
    },

    deleteAPIKey: {
        name: 'deleteAPIKey',
        query: `mutation deleteAPIKey($id: ID!){
            deleteAPIKey(id:$id)
        }`
    },

    firstGuideProfile: {
        name: 'getFirstGuideByProfileId',
        query: `query getFirstGuideByProfileId($profileId:String!){
            getFirstGuideByProfileId(profileId:$profileId) {
                status guideKey
            }
        }`
    },

    updateFirstGuideProfile: {
        name: 'updateFirstGuideByProfileId',
        query: `mutation updateFirstGuideByProfileId($input:UpdateFirstGuideInput!){
            updateFirstGuideByProfileId(input:$input)
        }`
    }
};

export default createGraphqlFetcher(apis);
